export enum OtherBaseVariableId {
  TODAY = 'today',
  TODAY_COMPACT = 'todayCompact',
  MENTIONS_LEGALES = 'mentionsLegales',
}
